module.exports = __webpack_public_path__ + "img/ufa-bet-support.58470b53.jpg";